import React, {Component,PropTypes} from 'react'
import {Link,Redirect} from 'react-router'
import NavBar from '../components/NavBar'
//import firebase from '../config/database';
//import Config, { userDetails } from   '../config/app';
// Required for side-effects


//require("firebase/firestore");

class App extends Component {
  constructor(props){
    super(props);
  }
  componentDidMount(){
    //Uncomment if you want to do a edirect
   // this.props.router.push('/firestoreadmin/cliniques') //Path where you want user to be redirected initialy
  }
  render() {

  return (
      <div className="content">
        <NavBar></NavBar>

        Dashboard
        <br />
        Add your own content here, instructions etc...
      </div>
    )
  }
}
export default App;




// WEBPACK FOOTER //
// ./src/containers/Biodigital.js